module.exports = new __parcel__URL__("plastic-ono-band.0e3f0451.jpg").toString();